import type { ProductResponse } from '@ydistri/api-sdk';
import type { MultiselectCustomerPartialEntity } from '../../global/ConfigurationMultiselect/configurationMultiselectTypes';

export const toScopeProductOptions = (
  products: ProductResponse[],
): MultiselectCustomerPartialEntity[] =>
  products.map(product => {
    const customerId = product.customerId ?? product.id.toString();

    return {
      id: product.id,
      // Scope rules save the internal Product ID, while the customer product ID remains visible.
      selectionValue: product.id.toString(),
      customerId,
      code: product.code,
      title: product.name,
      label: `#${customerId}${product.code ? ` (${product.code})` : ''} - ${product.name}`,
    };
  });

export const mergeScopeProductOptions = (
  current: MultiselectCustomerPartialEntity[],
  incoming: MultiselectCustomerPartialEntity[],
): MultiselectCustomerPartialEntity[] => {
  const byId = new Map(current.map(option => [option.id, option]));
  incoming.forEach(option => byId.set(option.id, option));
  return [...byId.values()];
};
